import { render } from "./UpgradePlans.vue?vue&type=template&id=2f4344bf"
import script from "./UpgradePlans.vue?vue&type=script&lang=js"
export * from "./UpgradePlans.vue?vue&type=script&lang=js"

import "./UpgradePlans.vue?vue&type=style&index=0&id=2f4344bf&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__